export default "__VITE_ASSET__HFqKKND___"